import MasterICCardStaffSettingPage from './MasterICCardStaffSettingPage';

export default MasterICCardStaffSettingPage;